import {
  ThemePerformanceSortHorizon,
  ThemePerformanceSubClass,
} from '@api/api/theme-overview';
import { useV5ThemePerformanceTimeseries } from '@terminal/react-query-hooks/themes/useV5ThemePerformanceTimeseries';
import { useV7ThemePerformanceTimeseries } from '@terminal/react-query-hooks/themes/useV7ThemePerformanceTimeseries';
import { useFlags } from '@terminal/stores/use-flags/useFlags';

export const useThemePerformanceTimeseries = (
  {
    themeId,
    horizon,
    subClass,
  }: {
    themeId: string;
    horizon: ThemePerformanceSortHorizon;
    subClass?: ThemePerformanceSubClass;
  },
  enabled = true
) => {
  const isV7ThemePerformance = useFlags(state =>
    state.getFeatureFlagState('KG-840-api_entity-performance-v7')
  );

  const v5Timeseries = useV5ThemePerformanceTimeseries(
    { themeId, horizon },
    enabled && !isV7ThemePerformance
  );
  const v7Timeseries = useV7ThemePerformanceTimeseries(
    { themeId, horizon, subClass },
    enabled && isV7ThemePerformance
  );

  return isV7ThemePerformance ? v7Timeseries : v5Timeseries;
};
